module.exports = __webpack_public_path__ + "img/zero-data-min.774c4abb.jpg";